var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__clip0_925_1888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5v5l3.333 1.667m5-1.667a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0z",
    stroke: "#fff",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__clip0_925_1888"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkyNV8xODg4KSI+CjxwYXRoIGQ9Ik05Ljk5OTg0IDUuMDAwMzNWMTAuMDAwM0wxMy4zMzMyIDExLjY2N00xOC4zMzMyIDEwLjAwMDNDMTguMzMzMiAxNC42MDI3IDE0LjYwMjIgMTguMzMzNyA5Ljk5OTg0IDE4LjMzMzdDNS4zOTc0NiAxOC4zMzM3IDEuNjY2NSAxNC42MDI3IDEuNjY2NSAxMC4wMDAzQzEuNjY2NSA1LjM5Nzk1IDUuMzk3NDYgMS42NjY5OSA5Ljk5OTg0IDEuNjY2OTlDMTQuNjAyMiAxLjY2Njk5IDE4LjMzMzIgNS4zOTc5NSAxOC4zMzMyIDEwLjAwMDNaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzkyNV8xODg4Ij4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgClock as ReactComponent };